module.exports = __webpack_public_path__ + "static/cs-2-c5e25baedbb11a1c53fb6054703aef89.jpg";